import { render, staticRenderFns } from "./PinnedCodeCoverageReport.vue?vue&type=template&id=5e693fe6&scoped=true"
import script from "./PinnedCodeCoverageReport.vue?vue&type=script&lang=ts"
export * from "./PinnedCodeCoverageReport.vue?vue&type=script&lang=ts"
import style0 from "./PinnedCodeCoverageReport.vue?vue&type=style&index=0&id=5e693fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e693fe6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,PinnableReportsList: require('/app/components/Reports/PinnableReportsList.vue').default,CodeCoverageTableLoading: require('/app/components/Reports/CodeCoverageTableLoading.vue').default,CodeCoverageTable: require('/app/components/Reports/CodeCoverageTable.vue').default,ChartContainer: require('/app/components/Reports/ChartContainer.vue').default})
